import { Stack, Typography } from "@mui/material";

import { useLocalizedDate } from "utils/date/useLocalizedDate";

interface NoteHeaderProps {
  date?: string | null;
  children: React.ReactNode;
}

export const RecordNoteHeader: React.FC<NoteHeaderProps> = ({ date, children }) => {
  const { format, isValid, parseISO } = useLocalizedDate();

  const getDate = () => {
    if (!date) {
      return "";
    }

    const parsedDate = parseISO(date);
    if (!isValid(parsedDate)) {
      return date;
    }

    return format(parsedDate, "PP");
  };

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems={{ xs: "flex-start", md: "center" }}
      spacing={{ xs: 0.5, md: 2 }}
      overflow="hidden"
    >
      <Typography variant="subtitle1" data-testid="record-note-date" sx={{ flexShrink: 0, minWidth: 96 }}>
        {getDate()}
      </Typography>
      <Typography
        variant="body_bold"
        sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginRight: 3 }}
      >
        {children}
      </Typography>
    </Stack>
  );
};
